(() => {
  if (window.__faunovProductCardReady) return;
  window.__faunovProductCardReady = true;
  document.addEventListener('click', (event) => {
    const card = event.target.closest('[data-p4-product-url]');
    if (!card || event.defaultPrevented || event.target.closest('a, button, form, product-form-component, add-to-cart-component')) return;
    if (card.dataset.p4ProductUrl) window.location.assign(card.dataset.p4ProductUrl);
  });
})();
